import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { BigqueryService } from './bigquery.service';
import { environment } from 'src/environments/environment';
import { Trending } from '../interfaces/trending.model';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private unknownImageUrl: string;

  constructor(
    private querySvc: BigqueryService,
    private http: HttpClient,
  ) { }

  /**
   * returns categoies from GCP functions
   */
  getCategories(): Observable<any> {
    return this.http.get<any[]>(`${environment.app.functionsUrl}/api/categories`);
  }

  /**
   * Returns Trending products
   */
  getTrendings(): Observable<Trending[]> {
    return this.http.get<Trending[]>(`${environment.app.functionsUrl}/api/trendings`);
  }

  getJsonData(file: string): Observable<any> {
    return this.http.get(`/assets/data/${file}.json`);
  }
}
